/**
 * Main entry point for the Smart Race Strategy application
 * This file initializes React and renders the root App component
 */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { OverlayPage } from "./pages/OverlayPage";
import "./index.css"; // Import Tailwind CSS styles

// Check if this is the overlay route
const isOverlay = window.location.pathname === "/overlay" ||
                  window.location.hash === "#overlay";

// Get the root DOM element where the React app will be mounted
const rootElement = document.getElementById("root");

// Ensure the root element exists before creating the React root
if (!rootElement) {
  throw new Error("Root element not found. Make sure there's a <div id='root'></div> in your HTML.");
}

// Create the React root and render the application
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    {isOverlay ? <OverlayPage /> : <App />}
  </React.StrictMode>
);
